import type { TenantCustomerConfig } from '@pelicargo/tenants';

// Fixed in the bundle on purpose: tenant config supplies values, never the script URL or code.
const scriptSrc = 'https://cdn.reamaze.com/assets/reamaze-loader.js';

type ReamazeConfig = NonNullable<TenantCustomerConfig['reamaze']>;

declare global {
  interface Window {
    _support?: Record<string, unknown>;
  }
}

export const bootReamaze = (config: ReamazeConfig, user: { email?: string; name?: string } = {}) => {
  if (window._support) return;

  window._support = {
    account: config.account,
    ui: {
      contactMode: 'mixed',
      enableKb: 'true',
      mailbox: config.mailbox,
      styles: { widgetColor: config.widgetColor, gradient: true },
      shoutboxFacesMode: '',
      widget: {
        allowBotProcessing: 'true',
        slug: config.slug,
        label: {
          text: config.greeting,
          mode: 'notification',
          delay: 3,
          duration: 30,
          primary: '',
          secondary: '',
          sound: true,
        },
        position: 'bottom-right',
      },
      overrides: { confirmationMessage: config.confirmationMessage },
    },
    user: { email: user.email, name: user.name },
    apps: { recentConversations: {}, faq: { enabled: true } },
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = scriptSrc;
  document.body.appendChild(script);
};
